import React, { useEffect } from 'react'
import { Card } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useUnit } from 'effector-react'

import { path } from '../../../../libs'
import { showNotification } from '../../../../features/notifications'
import {
  ChargebackForm,
  ChargebackFormData,
  toChargebackPayload,
} from '../widgets/ChargebackForm'
import { createChargeback, createChargebackMounted } from './model'

export const ChargebackCreatePage: React.FC = () => {
  const navigate = useNavigate()

  const loading = useUnit(createChargeback.pending)

  useEffect(() => {
    const unsubscribeDone = createChargeback.done.watch(() =>
      navigate(path.billing.chargeback.entry()),
    )
    const unsubscribeFail = createChargeback.failData.watch((data) =>
      showNotification({
        type: 'error',
        message: 'Error',
        description: data.body.message,
        placement: 'topRight',
      }),
    )
    return () => {
      unsubscribeDone()
      unsubscribeFail()
    }
  }, [navigate])

  const onSubmit = (data: ChargebackFormData) => {
    createChargebackMounted(toChargebackPayload(data))
  }

  return (
    <Card className="mb-4" title={<strong>Create chargeback</strong>}>
      <ChargebackForm
        onSubmit={onSubmit}
        loading={loading}
        submitLabel="Create"
      />
    </Card>
  )
}
